import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';

import { ISettingsGeneralDpoModel, ISettingsGeneralDpoUpdateCommand } from './settings-general-dpo.model';

@Injectable({
    providedIn: 'root',
})
export class SettingsGeneralDpoService {
    private apiUrl: string;
    private showDpo: boolean = null;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private loggerService: LoggerService,
        private translation: NDDTranslationService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-general`;
    }

    public getShow(): Observable<boolean> {
        if (this.showDpo !== null) {
            return of(this.showDpo);
        }

        return this.http.get<boolean>(`${ this.apiUrl }/show-dpo`)
            .pipe(tap({
                // Salva o retorno em uma variável, como trata-se de uma configuração salva em nddPrint.config que não será frequentemente alterada.
                next: (show: boolean): any => this.showDpo = show,
            }));
    }

    public getSettings(): Observable<ISettingsGeneralDpoModel> {
        return this.http.get<ISettingsGeneralDpoModel>(`${ this.apiUrl }/dpo`);
    }

    public updateSettings(command: ISettingsGeneralDpoUpdateCommand): Observable<boolean> {
        return this.http.post<boolean>(`${ this.apiUrl }/dpo`, command)
            .pipe(tap(() => this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')])));
    }
}
